import api from './client'
import type { BandListing } from '../types'

export interface BandListingParams {
  season?: number
  search?: string
  page?: number
  limit?: number
}

export interface BandListingResponse {
  listings: BandListing[]
  /** Seasons offered in the year filter, newest first. */
  seasons: number[]
  /** The season actually served, which is the newest one when none was asked for. */
  season: number | null
  total: number
  page: number
  limit: number
  totalPages: number
}

export async function getBandListings(params: BandListingParams = {}): Promise<BandListingResponse> {
  const { data } = await api.get<BandListingResponse>('/band-listings', { params })
  return data
}
